module.exports = __webpack_public_path__ + "static/media/inr_icon_anim.b476da89.glb";